import {PrimaryClientAddress} from "./PrimaryClientAddress";

/**
 * The {@link labelForPrimaryAddress} function generates a formatted string
 * from a {@link PrimaryClientAddress} for use as the label of a
 * {@link RadioButtonList} option.
 *
 * @param custName
 * @param address
 *
 * @see {@link toRadioButtonOption}
 */
export const labelForPrimaryAddress = ({
  entity: {custName},
  address
}: PrimaryClientAddress): string => {
  const lines = [];
  lines.push(custName);
  lines.push(address.addrLine1);
  if (address.addrLine2) {
    lines.push(address.addrLine2);
  }
  lines.push(`${address.city}, ${address.provinceCd} ${address.postalCd}`);
  lines.push(address.countryCd);
  return lines.join("\n");
};
